// extracted by mini-css-extract-plugin
module.exports = {"input":"PricePopover-module__input___6vRQq","applyClear":"PricePopover-module__applyClear___134-d"};